import { render } from "./PanelDownload.vue?vue&type=template&id=6ac5a72a&scoped=true&ts=true"
import script from "./PanelDownload.vue?vue&type=script&lang=ts"
export * from "./PanelDownload.vue?vue&type=script&lang=ts"

import "./PanelDownload.vue?vue&type=style&index=0&id=6ac5a72a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac5a72a"]])

export default __exports__